<template>
    <div class="tienda-section">
        <div class="tienda-content">
            <h1 class="tienda-title fuente-posm">
                Tu Propia Tienda en Línea + Plataformas Delivery
            </h1>
            <p class="tienda-text fuente-nova">
                Reduce Errores 90% • Aumenta Ventas 40%
                <br><br>
                Un solo sistema para gestionar todos tus pedidos. Vende directo a tus clientes sin comisiones y automatiza tus pedidos de Rappi y Uber Eats desde una sola plataforma.
            </p>
        </div>
        <div class="tienda-image">
            <img :src="a69" alt="Tienda en línea">
        </div>
    </div>
</template>

<script>
export default {
    name: 'TiendaEnLineaNew',
    data() {
        return {
            a69: require('@/assets/images/a69.webp')
        }
    }
}
</script>

<style lang="css" scoped>
.tienda-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 40px 60px;
    box-sizing: border-box;
    scroll-snap-align: start;
    gap: 40px;
}

.tienda-image {
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    order: 1;
}

.tienda-image img {
    width: 280px;
    height: auto;
}

.tienda-content {
    flex: 1;
    max-width: 700px;
    order: 2;
}

.tienda-title {
    color: var(--color-2);
    font-size: 68px;
    line-height: 1.1;
    margin: 0 0 20px 0;
}

.tienda-text {
    color: var(--color-3);
    font-size: 29px;
    line-height: 1.3;
    margin: 0;
    padding-left: 10px;
}

/* Tablet */
@media (max-width: 992px) and (min-width: 769px) {
    .tienda-title {
        font-size: 60px;
    }

    .tienda-text {
        font-size: 27px;
    }

    .tienda-image img {
        width: 220px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .tienda-section {
        flex-direction: column;
        justify-content: flex-start;
        height: 100vh;
        padding: 100px 20px 40px 20px;
        gap: 20px;
    }

    .tienda-content {
        order: 1;
        max-width: 100%;
        flex: none;
    }

    .tienda-image {
        order: 2;
        width: 100%;
        flex: 1;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding-top: 20px;
    }

    .tienda-image img {
        width: 60%;
        max-width: 240px;
    }

    .tienda-title {
        font-size: 24px;
        line-height: 1.2;
        margin: 0 0 10px 0;
    }

    .tienda-text {
        font-size: 16px;
        padding-left: 10px;
        margin: 0;
    }
}
</style>
